import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, withCtx as _withCtx, createBlock as _createBlock } from "vue"

const _hoisted_1 = /*#__PURE__*/_createElementVNode("h1", null, "Comprobación de autencidad.", -1)
const _hoisted_2 = { key: 0 }
const _hoisted_3 = { key: 1 }
const _hoisted_4 = /*#__PURE__*/_createElementVNode("div", { class: "spacer" }, null, -1)

import DefaultLayout from '@/layouts/DefaultLayout.vue'
import { ref, onMounted, Ref} from 'vue'
import SharedService from '@/services/SharedService'
import { useRoute } from 'vue-router'
import CheckI from '@/interfaces/CheckInterface'


export default /*#__PURE__*/_defineComponent({
  __name: 'CheckDiplomaView',
  setup(__props) {

const response:Ref<CheckI> = ref({})
const loading = ref(true)
const router = useRoute()

const sharedService = new SharedService()

onMounted(async () => {
    loading.value = true
    response.value = await sharedService.verifyDiplomaOwner(router.params.id)
    loading.value = false
})


return (_ctx: any,_cache: any) => {
  const _component_v_icon = _resolveComponent("v-icon")!

  return (_openBlock(), _createBlock(DefaultLayout, null, {
    default: _withCtx(() => [
      _hoisted_1,
      (loading.value)
        ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
            _createVNode(_component_v_icon, {
              name: "ri-loader-2-fill",
              animation: "spin",
              class: "icon"
            })
          ]))
        : (_openBlock(), _createElementBlock("div", _hoisted_3, [
            _hoisted_4,
            _createElementVNode("h3", null, _toDisplayString(response.value.message), 1)
          ]))
    ]),
    _: 1
  }))
}
}

})